const CONFIG = {
    'api_url': '', // 废弃
    'ga': '',
    'whiteboard_id': '76bdbed57a91aa4e93c43452bc55b87013ad17c12792a8c50614b628947cf8e4',
    'title': 'Jopus Manual', // 站点标题
    'pages': {
        'About': '6d30fd00-2557-49f7-9595-21d6dff24e7d',
        // 'Activity':'activity', // 花园活跃状态页面
        'Readme': '85122c3e-0d6c-488c-bfb3-02081838bd31'
    },
    'server': '', // Discord 服务器 ID，非必填，填写后将在网站中显示聊天入口
    'channel': '' // Discord 频道 ID，非必填，填写后将在网站中显示聊天入口
}

export default CONFIG
